import { Component, OnDestroy, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { select, Store } from '@ngrx/store';
import { first, take, takeUntil } from 'rxjs/operators';
import { PrimaryData, TaskStep } from 'app-models';
import { VisaExtendedState } from '../../utility/interfaces/visa-extended-state';
import { DirtyFormGuard, MarkCleanFormAction } from 'dirty-check-store';
import { Subject } from 'rxjs';
import { getStepDetails, updateStepStatus, updateStepStatusToInitialState } from 'visa-store';
import { StepStatusUpdatePayloadService } from 'step-status-update-payload-service';
import { environment } from 'environment-configurations';
import { EfilingService } from './efiling.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-efiling',
  templateUrl: './efiling.component.html',
  styleUrls: ['./efiling.component.scss']
})
export class EfilingComponent implements OnInit, OnDestroy {
  primaryData: PrimaryData;
  stepDetails: TaskStep;
  disabledControls: boolean;
  typeOfButton: string; // This is required for status update button
  observableSubscription$ = new Subject();
  sectionCode: string;
  showDownloadInstaller: boolean;
  selectedOS = "windows";
  efilingVersionData: any;

  constructor(
    private dynamicDialogRef: DynamicDialogRef,
    private dynamicDialogConfig: DynamicDialogConfig,
    private guard: DirtyFormGuard,
    private store: Store<VisaExtendedState>,
    public stepStatusUpdatePayloadService: StepStatusUpdatePayloadService,
    public efilingService: EfilingService,
    private toastr: ToastrService
  ) {
    this.primaryData = this.dynamicDialogConfig.data;
  }

  ngOnInit() {

    // work around for primeng radio button
    //console.log("this.primaryData efiling",this.primaryData);
    this.store.pipe(select(getStepDetails, { id: this.primaryData.stepId }))
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((data: TaskStep) => {
        this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? 'MARK_COMPLETE' : 'MARK_SUBMIT';
        this.sectionCode = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? 'PROC_INFO' : 'BEN_PROC_INFO';
        this.stepDetails = data;
        this.disabledControls =
          this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW' || this.stepDetails.stepStatusDetails.stepStatusCode === 'COMPLETE' ||
          this.stepDetails.stepStatusDetails.stepStatusCode === 'SUBMIT';
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
      });

    this.getEfilingVersionStatus();


  }
  getEfilingVersionStatus() {
    if (this.primaryData) {
      this.efilingService.getEfilingVersionStatus(this.primaryData.caseType)
        .pipe(take(1))
        .subscribe((response: any) => {
          if (response?.status === 200) {
            this.efilingVersionData = response.data;
          }
        });
    }
  }
  performAction() {
    this.showDownloadInstaller = true;
  }
  performLaunch() {
    let path = `/sponsor/${this.primaryData.sponsorId}/gc/${this.primaryData.superTaskId}/${this.primaryData.caseType.toLowerCase()}/efiling/downloadfiles`
    this.efilingService.getdownloadAllDocuments(path)
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: any) => {
        if (response) {
          if (response.data) {
            const filePath = environment.docs + response.data.message;
            this.downloadedFile(filePath);
          } else {
            this.toastr.success(response.message, 'Success');
          }

        }
      });
    window.location.href = 'efile-130://';
  }
  performDownload() {
    this.showDownloadInstaller = false;
    if (this.selectedOS === 'windows') {
      // window.location.href = 'http://34.235.141.147/I129-EFiling/i129-efiling.zip'
      window.location.href = `${environment.appUrl}/application/I130-EFiling/i130-efiling.zip`;
    } else {
      window.location.href = `${environment.appUrl}/application/I130-EFiling/i130-efiling.pkg`;
    }
  }

  closeDialog() {
    this.showDownloadInstaller = false;
    this.selectedOS = "windows";
  }

  handleClose() {
    this.guard.canDeactivate().pipe(first()).subscribe((response: boolean) => {
      if (response) {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
        this.dynamicDialogRef.close();
      }
      else {
        return false;
      }
    });
  }

  onSubmit() {
  }

  updateStepStatus(status) {
    this.store.dispatch(
      updateStepStatus({
        payload: this.stepStatusUpdatePayloadService.payloadConstruction(this.stepDetails, status),
        subTaskId: this.stepDetails.taskId,
        visaType: this.primaryData.caseType,
        stepId: this.primaryData.stepId
      }));
  }

  handleCancel() {

  }
  downloadedFile(url: string) {
    this.efilingService.downloadFile(url).subscribe((blob: Blob) => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `${this.primaryData.superTaskId}.tar`;
      link.click();
    });
    // this.btnApiService.downloadFile(url,'Filesummary')
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
    this.store.dispatch(updateStepStatusToInitialState());
  }

}

